<template>
  <content-container :showCastle="false">
    <h1>YOU FAILED</h1>
  </content-container>
</template>

<script>
import ContentContainer from "../../../components/content-container.vue";
export default {
  name: "party-form",
  components: {
    ContentContainer,
  },
};
</script>